import { render, staticRenderFns } from "./ezrich-withdraw.vue?vue&type=template&id=08f95e79&"
import script from "./ezrich-withdraw.vue?vue&type=script&lang=js&"
export * from "./ezrich-withdraw.vue?vue&type=script&lang=js&"
import style0 from "./ezrich-withdraw.vue?vue&type=style&index=0&id=08f95e79&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports